/**
 * This file contains the main app
 * @module App
 */
import * as THREE from 'three';
import React from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';

import ThreeScene from './components/ThreeScene';
import Controls from './components/Controls'
import Header from './components/Header'
import LoadIndicator from './components/LoadIndicator'
import Onboarding from './components/Onboarding'
import DetailView from './components/DetailView';
import { AppContext } from './util';
import { MOUSE_MOVE } from './events';
import './style.css';

export default class App extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isIntroVisible: true,
            isDataLoaded: false,
            isMediaLoaded: false,
            data: [],
            mousePosition: new THREE.Vector2()
        }

        this.fetchData();
	}
	
	componentDidMount() {
        PubSub.subscribe(MOUSE_MOVE, this.updateMouseMove);
	}

	updateMouseMove = (msg, mousePosition) => {
		this.setState({mousePosition});
	}

    fetchData() {
        window.fetch('/data/franz-marc-07-final.json')
            .then(response => response.json())
            .then(data => this.setState({isDataLoaded: true, data}))
            .catch(error => {
                alert('Error while loading data');
            });
    }

    /**
     * Render the component
     * @return {Object} JSX
     */
    render() {
	  
        const contextData = {
            data: this.state.data,
            mousePosition: this.state.mousePosition
        };

        return (
            <Router>
				<AppContext.Provider value={contextData}>
                    <Header />
                    <LoadIndicator />
					<Controls />
                    {this.state.isIntroVisible && <Onboarding handleIntroEnd={() => { this.setState({isIntroVisible: false} )}} />}
					{this.state.isDataLoaded && <ThreeScene data={this.state.data} mousePosition={this.state.mousePosition} />}
					<Route path="/detail/:id/:view?/" component={DetailView} />
                </AppContext.Provider>
            </Router>
        );
    }
}
